import { useCallback } from 'react';
import { get } from 'js/utils/fetch.util';
import { pick, prop } from 'js/utils/ramda.util';
import { useAppSelector, useUserSelector } from 'js/store/hooks';
import { parseGameFeeds, filterGames } from 'js/components/system/App/hooks/useGetGamesConfiguration/helpers';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';

export const useGetGamesConfiguration = () => {
    const getCMSResourceURL = useGetCMSResourceURL();
    const lang = useUserSelector(prop('lang'));
    const requestStamp = useAppSelector(prop('requestStamp'));
    const gamesData = useAppSelector(pick([
        'games',
        'gameTypes',
        'gamesFeeds',
        'gamesArticles',
        'isGamesLoaded',
        'gamesProviders',
        'gamesTilesLayouts',
        'gamesConfiguration'
    ]));

    return useCallback(async (disableCache) => {
        if (gamesData.isGamesLoaded && !disableCache) {
            const { isGamesLoaded, ...data } = gamesData;

            return data;
        }

        const requestURL = getCMSResourceURL(`/initialResources/games/${lang}`, { t: requestStamp || Date.now() });
        const { gamesConfiguration, gamesFeeds, ...other } = await get(requestURL);

        return {
            ...other,
            gamesConfiguration,
            gamesFeeds: parseGameFeeds(gamesFeeds),
            games: filterGames(gamesConfiguration)
        };
    }, [gamesData, lang, requestStamp, getCMSResourceURL]);
};
